export default function ancestry(list) {
  let map = {};
  let topLevel = [];

  for (let x of list) {
    map[x.id] = x;

    if (x.ancestry === null) {
      topLevel.push(x);
    } else {
      let parents = x.ancestry.split('/');
      x.parent = map[parents[parents.length - 1]];
      x.parent.children = x.parent.children || [];
      x.parent.children.push(x);
    }
  }

  return topLevel;
}
